<template>
  <form class="form-inline remark" style="margin-left: 0;">
    <b-container style="margin-left: 0;">
      <b-row align-v="center">
        <b-col cols="2" style="padding-left: 0;">
          <label class="text-left" style="justify-content: start;" for="remark"
            >Remark :</label
          >
        </b-col>
        <b-col cols="10">
          <b-row>
            <b-col>
              <!-- <b-form-select
                v-if="!otherRemark"
                v-model="remarkLocalInput"
                name="remark"
                :options="getRemarks"
                text-field="remarks"
                :value-field="remarks"
                :class="inputClass"
                style="width: 100%"
              >
                <template v-slot:first>
                  <option
                    :value="null"
                    disabled
                  >
                    -- เลือก remark ที่มีอยู่ --
                  </option>
                </template>
              </b-form-select> -->
              <multiselect
                class="inputClass"
                style="min-width: 200px;"
                v-model="remarkLocalInput"
                :tabindex="-1"
                :options="getRemarks"
                :multiple="true"
                label="remarks"
                track-by="id"
                select-label=""
                deselect-label="✖"
                selected-label=""
                placeholder="เลือก remark ที่มีอยู่ "
              />
              <b-form-input
                v-model="otherRemarkLocalInput"
                style="width: 100%;"
                placeholder="พิมพ์ remark อื่นๆ"
              />
            </b-col>
          </b-row>
          <!-- <b-row style="padding-top: 1rem; margin: auto 0;">
            <b-col cols="auto">
              <b-form-checkbox
                v-model="otherRemark"
                @change="changeRemarkStep"
              >
                อื่นๆ
              </b-form-checkbox>
            </b-col>
            <b-col cols="auto" />
          </b-row> -->
        </b-col>
      </b-row>
    </b-container>
  </form>
</template>

<script>
export default {
  name: "RemarkComponent",
  props: {
    remarkInput: {
      required: true,
    },
    getRemarks: {
      required: true,
    },
    label: {
      required: true,
    },
    trackBy: {
      required: true,
    },
    inputClass: {
      default: "",
    },
    placeHolder: {
      default: "Select Option",
    },
    remarkInit: {
      default: "",
    },
    otherRemarkInit: {
      default: "",
    },
    otherRemark: {
      default: "",
    },
  },
  data() {
    return {
      remarkLocalInput: null,
      otherRemarkLocalInput: "",
    };
  },
  watch: {
    remarkLocalInput(newVal, oldVal) {
      this.$emit("update:remarkInput", newVal);
    },
    otherRemarkLocalInput(newVal) {
      this.$emit("update:otherRemark", newVal);
    },
  },
  created() {
    this.otherRemarkLocalInput = this.otherRemarkInit;
    this.remarkLocalInput = this.remarkInit;
    // if (!this.getRemarks.find(remark => remark.remarks === this.remarkLocalInput)) {
    //     if (this.remarkLocalInput) {
    //         this.otherRemark = true;
    //     }
    // }
  },
  methods: {
    changeInput(el) {
      this.$emit("update:remarkInput", this.remarkLocalInput);
    },
    changeRemarkStep() {
      this.remarkLocalInput = null;
    },
  },
};
</script>

<style lang="scss" scoped></style>
